(function () {
  'use strict';
  var FORM_ID = 'forms-root-1162667';
  var INTEREST_MAP = [
    [/portable/i, 'Portable Water Heater'],
    [/tankless|tank\s*water\s*heater|instashower|water\s*heater/i, 'RV Water Heater'],
    [/air\s*condition|instacool|\bA\/?C\b/i, 'RV Air Conditioner'],
    [/furnace|heater\s*with\s*duct/i, 'RV Furnace'],
    [/kitchen|range|cooktop|oven/i, 'RV Kitchen Appliance']
  ];

  function findEmbed(root) {
    return root.querySelector('[data-fgb2b-forms-app] [data-forms-id="' + FORM_ID + '"] shopify-forms-embed');
  }
  function getForm(root) {
    var embed = findEmbed(root);
    return embed && embed.shadowRoot ? embed.shadowRoot.querySelector('form[data-testid="form"]') : null;
  }
  function interestFor(title, form) {
    var boxes = Array.prototype.slice.call(form.querySelectorAll('input[type="checkbox"][name="custom#product_interest"]'));
    var exact = boxes.find(function (box) { return box.value.trim().toLowerCase() === title.trim().toLowerCase(); });
    if (exact) return exact;
    for (var i = 0; i < INTEREST_MAP.length; i++) {
      if (INTEREST_MAP[i][0].test(title)) {
        var match = boxes.find(function (box) { return box.value === INTEREST_MAP[i][1]; });
        if (match) return match;
      }
    }
    return null;
  }
  function installShadowStyles(root, shadow) {
    if (shadow.querySelector('link[data-fgb2b-shadow-style]')) return;
    var href = root.getAttribute('data-fgb2b-forms-css');
    if (!href) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.setAttribute('data-fgb2b-shadow-style', '');
    shadow.appendChild(link);
  }
  function initTerms(root, form) {
    var fieldset = form.querySelector('fieldset[name="custom#dealer_program_terms"]');
    if (!fieldset || form.querySelector('.fgb2b-shadow-terms-link')) return;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'fgb2b-shadow-terms-link';
    button.textContent = 'Read full Dealer Program Terms ↗';
    button.addEventListener('click', function () {
      var dialog = root.querySelector('[data-fgb2b-terms-dialog]');
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') dialog.showModal();
    });
    fieldset.insertAdjacentElement('afterend', button);
  }
  function initDialog(root) {
    var dialog = root.querySelector('[data-fgb2b-terms-dialog]');
    if (!dialog || dialog.dataset.fgb2bBound) return;
    dialog.dataset.fgb2bBound = 'true';
    dialog.querySelectorAll('[data-fgb2b-terms-close]').forEach(function (button) {
      button.addEventListener('click', function () { dialog.close(); });
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
  }
  function setExpanded(root, expanded) {
    var card = root.querySelector('[data-fgb2b-forms-card]');
    var toggle = root.querySelector('[data-fgb2b-form-toggle]');
    if (!card || !toggle) return;
    card.classList.toggle('fgb2b__is-collapsed', !expanded);
    toggle.setAttribute('aria-expanded', String(expanded));
    var text = toggle.querySelector('[data-fgb2b-form-toggle-text]');
    if (text) text.textContent = expanded ? 'Collapse Application' : 'View Full Application';
  }
  function initCollapse(root) {
    var toggle = root.querySelector('[data-fgb2b-form-toggle]');
    if (!toggle || toggle.dataset.fgb2bBound) return;
    toggle.dataset.fgb2bBound = 'true';
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      setExpanded(root, !expanded);
      if (expanded) root.querySelector('[data-fgb2b-forms-card]').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    // Start collapsed only when Shopify's form has loaded; prevents hiding setup/errors.
    var form = getForm(root);

    if (
      form &&
      !form.querySelector('[aria-invalid="true"], [role="alert"]')
    ) {
      setExpanded(root, false);
    }
  }
  function initFormEvents(root, form) {
    if (form.dataset.fgb2bEventsBound) return;
    form.dataset.fgb2bEventsBound = 'true';
    form.addEventListener('submit', function () { setExpanded(root, true); }, true);
    form.addEventListener('focusin', function () { setExpanded(root, true); });
    // Validation errors are rendered by Shopify Forms; reveal them when present.
    var observer = new MutationObserver(function () {
      if (form.querySelector('[aria-invalid="true"], [role="alert"]')) setExpanded(root, true);
    });
    observer.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-invalid'] });
  }
  function initPartnerPage(root) {
    if (!root || root.dataset.fgb2bInitialized === 'true') return;
    root.dataset.fgb2bInitialized = 'true';
    var formSection = root.querySelector('[data-fgb2b-form]');
    initDialog(root);
    initCollapse(root);
    root.querySelectorAll('[data-fgb2b-interest]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (!formSection) return;
        event.preventDefault();
        setExpanded(root, true);
        var title = link.getAttribute('data-fgb2b-interest') || '';
        var form = getForm(root);
        var checkbox = form && interestFor(title, form);
        if (checkbox && !checkbox.checked) {
          checkbox.click(); // React-controlled input: use real click, not checked=true alone
        }
        formSection.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
        window.setTimeout(function () {
          if (checkbox) checkbox.focus({ preventScroll: true });
        }, 450);
      });
    });
    // Shopify Forms is loaded asynchronously and can re-render on validation.
    var app = root.querySelector('[data-fgb2b-forms-app]');
    if (!app) return;
    var timer;
    function refresh() {
      var embed = findEmbed(root);
      if (!embed || !embed.shadowRoot) return;
      installShadowStyles(root, embed.shadowRoot);
      var form = getForm(root);
      if (form) {
        initTerms(root, form);
        initFormEvents(root, form);
        var toggle = root.querySelector('[data-fgb2b-form-toggle]');
        if (toggle && !toggle.dataset.fgb2bInitialState) {
          toggle.dataset.fgb2bInitialState = 'true';

          if (
            !form.querySelector('[aria-invalid="true"], [role="alert"]')
          ) {
            setExpanded(root, false);
          } else {
            setExpanded(root, true);
          }
        }
      }
    }
    var observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(refresh, 30);
    });
    observer.observe(app, { childList: true, subtree: true });
    refresh();
    // Shadow-root mutations do not bubble to the light DOM observer.
    var shadowObserver = null;
    var previousShadow = null;
    var watch = setInterval(function () {
      if (!root.isConnected) { clearInterval(watch); observer.disconnect(); if (shadowObserver) shadowObserver.disconnect(); return; }
      var embed = findEmbed(root);
      var shadow = embed && embed.shadowRoot;
      if (shadow && shadow !== previousShadow) {
        if (shadowObserver) shadowObserver.disconnect();
        previousShadow = shadow;
        shadowObserver = new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(refresh, 30); });
        shadowObserver.observe(shadow, { childList: true, subtree: true });
      }
      refresh();
    }, 800);
  }
  function initAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches('[data-fgb2b]')) initPartnerPage(context);
    context.querySelectorAll('[data-fgb2b]').forEach(initPartnerPage);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
